export default {
  USED: 'used',
  NEW: 'new',
};
